import React, {ReactNode} from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

type Props = {
  rightSlot?: ReactNode
  leftSlot?: ReactNode
}

const Container = styled.div`
  /* Push element to a new paint layer to avoid Chrome bug that would cause it to disappear - sc-79945 */
  transform: translateZ(1px);
  position: absolute;
  z-index: 2;
  top: ${cssTheme.layout.spacing.s400};
  right: ${cssTheme.layout.spacing.s300};
  left: ${cssTheme.layout.spacing.s300};
`

const Side = styled.div`
  display: flex;
  position: absolute;
  gap: ${cssTheme.layout.spacing.s250};
  &.--left-aligned {
    left: 0;
  }
  &.--right-aligned {
    right: 0;
  }
`

export const AccommodationFloatingHeader = ({rightSlot, leftSlot}: Props) => {
  if (!rightSlot && !leftSlot) {
    throw new Error('At least one of rightSlot or leftSlot must be provided.')
  }
  return (
    <Container>
      {rightSlot && <Side className="--right-aligned">{rightSlot}</Side>}
      {leftSlot && <Side className="--left-aligned">{leftSlot}</Side>}
    </Container>
  )
}
